// #tag: ORDINAL SEQUENCE POSITION FORMATTER
// #purpose: Formats numeric sequence ranks into human-readable English ordinals (1st, 2nd, 3rd, 4th).
export function formatSequencePosition(position: number): string {
  const n = Math.trunc(position);
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${n}th`;
  switch (n % 10) {
    case 1: return `${n}st`;
    case 2: return `${n}nd`;
    case 3: return `${n}rd`;
    default: return `${n}th`;
  }
}
